import React, {useState} from "react";
import Window from "./window";
import {connect, useDispatch} from "react-redux";
import {setGuiState} from "../../data/actions";

const Windowbutton = ({gs, children, icon, headline, id, width}) => {
    const dispatch = useDispatch()

    const _show = gs && gs.show || false

    function show(e) {
        dispatch(setGuiState({
            id: id,
            show: !_show,
        }))
    }

    function close() {
        dispatch(setGuiState({
            id: id,
            show: false,
        }))
    }

    return(
        <>
            <div className={'bubble'}
                 style={{
              }} onClick={(e) => show(e)}>{icon}</div>
            {_show?
                <Window id={id} close={close} headline={headline} icon={icon} width={width}>
                    {children}
                </Window>
                :null}
        </>
    )
}

function mapStateToProps(state, other) {
    var itm = state.root.gui_state.find((itm) => {
        return itm.id === other.id
    });
    return {...state, gs: itm}
}

export default connect(mapStateToProps)(Windowbutton)
